var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('link-base',{staticClass:"link-side-menu",on:{"click":_vm.clickEvent}},[_c('image-base',{staticClass:"link-side-menu__icon",attrs:{"src":require(`@/assets/img/${_vm.img}`)}}),_c('div',{staticClass:"link-side-menu__text text-xlarge font-bold"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }